import { render, staticRenderFns } from "./showEmailMsg.vue?vue&type=template&id=78a6babb&scoped=true&"
import script from "./showEmailMsg.vue?vue&type=script&lang=js&"
export * from "./showEmailMsg.vue?vue&type=script&lang=js&"
import style0 from "./showEmailMsg.vue?vue&type=style&index=0&id=78a6babb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a6babb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78a6babb')) {
      api.createRecord('78a6babb', component.options)
    } else {
      api.reload('78a6babb', component.options)
    }
    module.hot.accept("./showEmailMsg.vue?vue&type=template&id=78a6babb&scoped=true&", function () {
      api.rerender('78a6babb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/components/showEmailMsg.vue"
export default component.exports